import { useCallback } from 'react';

import { useNewAuth } from '@/providers/AuthProvider/NewAuthProvider.hooks';
import { useEntitiesAccess } from '@/hooks/useEntitiesAccess';

export const useStablecoinsAccess = () => {
  const { user } = useNewAuth();
  const { isEntityAllowed } = useEntitiesAccess();

  const isAccessResolved = !!user;

  const isStablecoinAllowed = useCallback(
    (agioId: string) => isAccessResolved && isEntityAllowed(agioId),
    [isAccessResolved, isEntityAllowed],
  );

  return { isAccessResolved, isStablecoinAllowed };
};
